export enum CandidateProfileListType {
  CANDIDATES_LIST = 'CANDIDATES_LIST',
  CANDIDATES_FROM_TALENT_POOL = 'CANDIDATES_FROM_TALENT_POOL',
  ADD_CANDIDATES_TO_TALENT_POOL = 'ADD_CANDIDATES_TO_TALENT_POOL',
  ANALYSIS_CANDIDATES_LIST = 'ANALYSIS_CANDIDATES_LIST',
  ANALYSIS_CANDIDATES_FROM_TALENT_POOL = 'ANALYSIS_CANDIDATES_FROM_TALENT_POOL'
}

export type CandidateProfileListProps =
  | {
      type: CandidateProfileListType.CANDIDATES_LIST;
    }
  | {
      type: CandidateProfileListType.CANDIDATES_FROM_TALENT_POOL;
      talentPoolId: string;
    }
  | {
      type: CandidateProfileListType.ADD_CANDIDATES_TO_TALENT_POOL;
      talentPoolId: string;
    }
  | {
      type: CandidateProfileListType.ANALYSIS_CANDIDATES_LIST;
      candidateBatchId: string;
    }
  | {
      type: CandidateProfileListType.ANALYSIS_CANDIDATES_FROM_TALENT_POOL;
      candidateBatchId: string;
      talentPoolId: string;
    };
